import {
  LOADING,
  RESULT,
  LIST,
  INIT_CREATE,
  CREATE,
  READ,
  UPDATE,
  DELETE,
  LIST_INGREDIENT,
  REFILL_LIST
} from './actionTypes';

export const loading = actionType => ({
  type: LOADING,
  payload: { actionType },
});

export const result = (actionType, result) => ({
  type: RESULT,
  payload: { actionType, result },
});

export const list = id => ({
  type: LIST,
  id
});
export const list_ingredients = () => ({
  type: LIST_INGREDIENT,
});
export const refill_list = () => ({
  type: REFILL_LIST,
});

export const initCreate = () => ({
  type: INIT_CREATE,
});

export const create = payload => ({
  type: CREATE,
  payload,
});

export const read = sku => ({
  type: READ,
  payload: { sku },
});

export const update = payload => ({
  type: UPDATE,
  payload,
});


export const delete_ = sku => ({
  type: DELETE,
  payload: { sku },
});
